import React from 'react';
import PropTypes from 'prop-types';
import {publicBuildUrl} from '../../config/config';

const texts = {
    1: 'Welkom!',
    2: 'Kijk naar de animatie.',
    3: 'Beantwoord de vragen over de animatie.',
    4: 'Speel de minigame.',
    5: 'Kijk naar de animatie.',
    6: 'Is de situatue wel/niet oke? Gebruik de tool (...)',
    7: 'Samen: waarom is de situatie wel/niet oke? Uitleg van de tool (...)',
    8: 'Wat kan in deze situatie helpen?',
    9: 'Samen: wat kan in deze situatie helpen?',
    10: 'Gezamelijke afsluiting.',
}

const GameStep = ({hasNextStep = true, step}) => (
    <div style={styles.container}>
        <div style={styles.containerTop}>
            <div style={styles.imageContainer}>
                <img src={`${publicBuildUrl}icons/IconGameFlow${step}.png`} alt={''} style={{width: '160px'}}/>
            </div>
            {hasNextStep &&
            <div style={styles.nextContainer}>
                <div>
                    <img src={`${publicBuildUrl}icons/IconArrow.png`} alt={''} style={{marginLeft: '25px', marginRight: '25px'}}/>
                </div>
            </div>}
        </div>

        <div style={{
            ...styles.text,
        }}>
            {texts.hasOwnProperty(step) && texts[step]}
        </div>
    </div>
);

GameStep.propTypes = {
    hasNextStep: PropTypes.bool,
    step: PropTypes.number.isRequired,
};

const styles = {
    container: {
        width: '100%'
    },
    containerTop: {
        display: 'flex'
    },
    imageContainer: {
        flexGrow: 1
    },
    nextContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContents: 'center',
    },
    text: {
        color: '#003d4c',
        fontFamily: 'Ubuntu',
        fontSize: '18px',
        fontWeight: 500,
        marginTop: '10px',
        textAlign: 'center',
    }
}

export default GameStep;
